import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { userAtom } from '@root/entities/auth'
import { referralCodeAtom } from '@root/entities/referral'
import { Trend } from '@root/entities/trend'
import { FlameIcon } from '@root/shared/ui-kit'

import { PnlPositionShareDialog } from './pnl-position-share-dialog'

import type { Pair } from '@root/entities/pair'
import type { WalletPositionModel } from '@root/entities/position'

type Props = {
  pair: Pair.PairMinimal
  position: WalletPositionModel
  withOutline?: boolean
}

export const PnLShareDialogButton: React.FC<Props> = ({
  position,
  pair,
  withOutline = false,
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [user] = useAtom(userAtom)
  const [pnl] = useAtom(position.totalPnlUsd)
  const trend = Trend.of(pnl.pnlPercentage)
  const [referralCode] = useAtom(referralCodeAtom)

  if (user) {
    return (
      <>
        <Button
          $withOutline={withOutline}
          onClick={() => setOpen((x) => !x)}
          data-trend={trend}
        >
          <FlamePnLIcon size={12} /> {t('common.pnl')}
        </Button>
        <PnlPositionShareDialog
          user={user}
          referralCode={referralCode}
          position={position}
          pair={pair}
          open={open}
          onOpenChange={setOpen}
        />
      </>
    )
  }
}

const Button = styled.div<{ $withOutline: boolean }>`
  color: var(--text-1);

  &[data-trend='up'] {
    background: var(--upAccent-9);
    outline: ${(x) =>
      x.$withOutline ? '1px solid var(--upAccent-9);' : 'none'};
    outline-offset: 1.5px;

    outline: 1px solid var(--upAccent-9);
  }
  &[data-trend='neutral'] {
    color: var(--text-11);
  }
  &[data-trend='down'] {
    background: var(--downAccent-9);
    outline: ${(x) =>
      x.$withOutline ? '1px solid var(--downAccent-9);' : 'none'};
    outline: 1px solid var(--downAccent-9);
    outline-offset: 1.5px;
  }

  border-radius: 6px;
  padding: 2px 7px;

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  gap: 2px;

  font-size: 11px;
  font-weight: 700;
  line-height: 16px;

  font-style: normal;
  align-items: center;
  cursor: pointer;
  text-transform: uppercase;

  transition:
    background,
    outline 0.2s ease-in-out;

  &:hover {
    &[data-trend='up'] {
      background: var(--upAccent-10);
    }
    &[data-trend='neutral'] {
      color: var(--text-11);
    }
    &[data-trend='down'] {
      background: var(--downAccent-10);
    }
  }
`

const FlamePnLIcon = styled(FlameIcon)``
